import { render, staticRenderFns } from "./ComparisonTableSummary.vue?vue&type=template&id=51161e83&scoped=true"
import script from "./ComparisonTableSummary.vue?vue&type=script&lang=js"
export * from "./ComparisonTableSummary.vue?vue&type=script&lang=js"
import style0 from "./ComparisonTableSummary.vue?vue&type=style&index=0&id=51161e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51161e83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VToolbar,VToolbarTitle})
